/**
 * @flow
 * @relayHash 77fc66415a201fbfba25570ec6729813
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StreamAddInput = {
  title: string,
  description?: ?string,
  topics?: ?$ReadOnlyArray<?string>,
  video?: ?string,
  availableAt?: ?string,
  active?: ?boolean,
  screen?: ?boolean,
  rating?: ?string,
  state?: ?string,
  linkedArticles?: ?$ReadOnlyArray<?string>,
  videoFile?: ?string,
  preview?: ?string,
  clientMutationId?: ?string,
};
export type StreamAddMutationVariables = {|
  input: StreamAddInput
|};
export type StreamAddMutationResponse = {|
  +StreamAdd: ?{|
    +streamEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type StreamAddMutation = {|
  variables: StreamAddMutationVariables,
  response: StreamAddMutationResponse,
|};
*/


/*
mutation StreamAddMutation(
  $input: StreamAddInput!
) {
  StreamAdd(input: $input) {
    streamEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "StreamAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "StreamAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "StreamAddInput!"
      }
    ],
    "concreteType": "StreamAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "streamEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "StreamEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Stream",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "StreamAddMutation",
  "id": null,
  "text": "mutation StreamAddMutation(\n  $input: StreamAddInput!\n) {\n  StreamAdd(input: $input) {\n    streamEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "StreamAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "StreamAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7c023105c68e565df8d70da341cdde21';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/StreamAddMutation.graphql.js